import { render, staticRenderFns } from "./CustomEmailForm.vue?vue&type=template&id=801d2b60&scoped=true&"
import script from "./CustomEmailForm.vue?vue&type=script&lang=js&"
export * from "./CustomEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomEmailForm.vue?vue&type=style&index=0&id=801d2b60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801d2b60",
  null
  
)

export default component.exports